import { ChevronLeft, ChevronRight, Download, ZoomIn } from "lucide-react";
import React, { useEffect, useState } from "react";
import { ActionIcon, Modal } from "@mantine/core";
import { InboxQueryDetails } from "../utils/types";
import { downloadImage } from "../../../utils/File";

interface SupportingDocumentsProps {
  supportingDocuments: string[];
  ticket: InboxQueryDetails;
}
const SupportingDocuments = ({
  supportingDocuments,
  ticket,
}: SupportingDocumentsProps): JSX.Element => {
  const pages = supportingDocuments.length;
  const [page, setPage] = useState(1);
  const [selectedDocument, setSelectedDocument] = useState(
    supportingDocuments[0]
  );
  const [supportingDocumentOpened, setSupportingDocumentOpened] =
    useState(false);

  useEffect(() => {
    if (page < 1) {
      setPage(1);
      return;
    }
    if (page > pages) {
      setPage(pages);
      return;
    }
    setSelectedDocument(supportingDocuments[page - 1]);
  }, [page]);

  return (
    <div className="flex flex-col h-full max-h-full">
      <div className="relative w-full max-h-full grow">
        <img
          src={selectedDocument}
          alt="Supporting Document"
          className="absolute inset-0 object-contain w-full h-full"
        />
      </div>
      <Modal
        size="80%"
        opened={supportingDocumentOpened}
        onClose={() => setSupportingDocumentOpened(false)}
        title={ticket.query_type}
      >
        <img
          src={selectedDocument}
          alt="Supporting Document"
          className="w-full h-auto"
        />
      </Modal>
      <div className="flex justify-between p-2 border-t border-jem-shade">
        <div className="flex items-center gap-4">
          <span className="font-xs" style={{ color: "rgb(73, 80, 87)" }}>
            Image {page} of {pages}
          </span>
          <div className="flex gap-2">
            <ActionIcon
              className={`border rounded !bg-transparent ${
                page === pages || pages === 1
                  ? "border-jem-primary-50t/50"
                  : "border-jem-primary-50t"
              }`}
              disabled={page === 1 || pages === 1}
              onClick={() => setPage(page - 1)}
              size={32}
            >
              <ChevronLeft
                size={16}
                className={
                  page === pages
                    ? "text-jem-primary-base/50"
                    : "text-jem-primary-base"
                }
              />
            </ActionIcon>
            <ActionIcon
              className={`border rounded !bg-transparent ${
                page === pages || pages === 1
                  ? "border-jem-primary-50t/50"
                  : "border-jem-primary-50t"
              }`}
              disabled={page === pages || pages === 1}
              onClick={() => setPage(page + 1)}
              size={32}
            >
              <ChevronRight
                size={16}
                className={
                  page === pages
                    ? "text-jem-primary-base/50"
                    : "text-jem-primary-base"
                }
              />
            </ActionIcon>
          </div>
        </div>
        <div className="flex gap-4">
          <ActionIcon
            className="border rounded border-jem-primary-50t"
            onClick={() => downloadImage(selectedDocument || "")}
            size={32}
          >
            <Download size={16} className="text-jem-primary-base" />
          </ActionIcon>
          <ActionIcon
            className="border rounded border-jem-primary-50t"
            onClick={() => setSupportingDocumentOpened(true)}
            size={32}
          >
            <ZoomIn size={16} className="text-jem-primary-base" />
          </ActionIcon>
        </div>
      </div>
    </div>
  );
};

export default SupportingDocuments;
